import { useEffect } from 'react';

const DEFAULT_TITLE = document.title;

function useDocumentTitle(title: string) {
    useEffect(() => {
        document.title = title;
        return () => {
            document.title = DEFAULT_TITLE;
        };
    }, [title]);
}

export default useDocumentTitle;
